import React from 'react';
import { Fuel, Zap } from 'lucide-react';
import { useT } from '../services/i18n';
import { ENERGIES, energyLabel } from '../services/fuel';

const COLORS = { essence: 'bg-emerald-50 text-emerald-800 border-emerald-200', diesel: 'bg-slate-100 text-slate-800 border-slate-300', electrique: 'bg-sky-50 text-sky-800 border-sky-200' };

// Small pill « Essence · Diesel » — nothing rendered when the product fits every powertrain (unless showAll)
export const FuelBadge = ({ types, testId = 'fuel-badge', showAll = false, size = 'xs' }) => {
  const { t } = useT();
  const list = ENERGIES.filter(e => (types || []).includes(e));
  if (!list.length && !showAll) return null;
  const cls = size === 'sm' ? 'text-xs px-2.5 py-1' : 'text-[11px] px-2 py-0.5';
  if (!list.length) return <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full border bg-gray-50 text-gray-500 border-gray-200 ${cls}`}>{t('fuelR.all')}</span>;
  return (
    <span className="inline-flex flex-wrap gap-1" data-testid={testId}>
      {list.map(e => (
        <span key={e} data-testid={`${testId}-${e}`} className={`inline-flex items-center gap-1 rounded-full border font-medium ${COLORS[e]} ${cls}`}>
          {e === 'electrique' ? <Zap size={11} /> : <Fuel size={11} />} {energyLabel(t, e)}
        </span>
      ))}
    </span>
  );
};

export default FuelBadge;
